import React from 'react';
import { Icon } from '@iconify/react';
import { useNavigate } from 'react-router-dom';

interface UXGenieHeaderProps {
  uxgenieWorker?: any;
  routeAiworkerId?: string;
  isViewingTemplate: boolean;
  hasGeneratedTemplate: boolean;
  currentActionName?: string | null;
  onBack: () => void;
}

export const UXGenieHeader: React.FC<UXGenieHeaderProps> = ({
  uxgenieWorker,
  routeAiworkerId,
  isViewingTemplate,
  hasGeneratedTemplate,
  currentActionName,
  onBack,
}) => {
  const navigate = useNavigate();

  // Use worker name if available, fall back to a generic label when only the ID is known
  const workerName = uxgenieWorker?.name || (routeAiworkerId ? 'Templates' : null);
  const showWorkerCrumb = !!(routeAiworkerId || uxgenieWorker);

  const modeLabel = isViewingTemplate
    ? 'View Template'
    : hasGeneratedTemplate
      ? 'Edit Template'
      : 'Create Template';

  return (
    <div className="flex items-center justify-between px-3 py-1.5 border-b bg-default-100">
      <nav className="flex items-center gap-1 text-sm">
        <button
          onClick={() => navigate('/uxgenie')}
          className="text-blue-600 hover:text-blue-800 transition-colors"
        >
          UXGenie Templates
        </button>

        {showWorkerCrumb && workerName && (
          <>
            <Icon icon="mdi:chevron-right" width={14} className="text-default-400 flex-shrink-0" />
            <button
              onClick={onBack}
              className="text-blue-600 hover:text-blue-800 transition-colors"
            >
              {workerName}
            </button>
          </>
        )}

        <Icon icon="mdi:chevron-right" width={14} className="text-default-400 flex-shrink-0" />
        <span className="text-blue-700 font-medium">{modeLabel}</span>
      </nav>

      {currentActionName && (
        <div className="flex items-center gap-1.5">
          <span className="text-sm text-default-500">Action:</span>
          <span className="px-2 py-0.5 bg-blue-100 text-blue-700 rounded-full text-sm font-medium">
            {currentActionName}
          </span>
        </div>
      )}
    </div>
  );
};
